import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgGolap = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 20 21'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#2929A3'
      d='M2 8a5.5 5.5 0 0 0 3.205 5H2a5.5 5.5 0 0 0 10.5 2.294V18.5A5.5 5.5 0 0 0 14.794 8H18A5.5 5.5 0 0 0 7.5 5.705V2.5A5.5 5.5 0 0 0 2 8'
    />
    <path fill='#FF6680' d='M12.5 10.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0' />
  </svg>
)
const ForwardRef = forwardRef(SvgGolap)
export default ForwardRef
